var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "2.2,5.4 21.4,5.4 21.9,18.5 2.2,18.6  "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4,5.4H21V7h-1V5.4H4v9.1H3V5.4H1.5C1,5.4,1,5.8,1,5.8v12.3c0,0.4,0.6,0.5,0.6,0.5h1.5V17h1v1.6H20V9.5h1 v9.1h1.4c0.6-0.1,0.6-0.4,0.6-0.4V5.9C22.9,5.4,22.4,5.4,22.4,5.4z M10.3,16.5H9.8l1.3-4.2H9.2l0.4-4.5c0,0,0.1-0.3,0.4-0.3h3.6 c0,0,0.3-0.1,0.2,0.3l-1.2,2.8h2.1L10.3,16.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.4f330b1a7f112327c1c231c672046eff.svg";
export { ForwardRef as ReactComponent };